<template>
    <router-link :to="link" 
        class="home-feature flex-1 flex text-center justify-center items-center p-10 bg-gray-200 bg-cover bg-center h-64"
        :style="{ backgroundImage: 'url(' + image + ')' }"
    >
        <h2 class="text-white leading-none text-3xl">{{ label }}</h2>
    </router-link>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Feature'
    },
    image: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: '/'
    }
  }
}
</script>
